const dataURLToBlob = function (dataURL) {
  let BASE64_MARKER = ';base64,'

  if (dataURL.indexOf(BASE64_MARKER) === -1) {
    let parts = dataURL.split(',')
    let contentType = parts[0].split(':')[1]
    let raw = decodeURIComponent(parts[1])

    return new Blob([raw], { type: contentType })
  }

  let parts = dataURL.split(BASE64_MARKER)
  let contentType = parts[0].split(':')[1]
  let raw = window.atob(parts[1])
  let rawLength = raw.length

  let uInt8Array = new Uint8Array(rawLength)

  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i)
  }

  return new Blob([uInt8Array], { type: contentType })
}

const formatDate = function (start, end) {
  let startF = parseDate(start)
  if (start !== end) {
    let endF = parseDate(end)
    return `${startF}–${endF}`
  } else if (end.length > 0) {
    return `${startF}`
  }
}

const parseDate = function (date) {
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ]
  const dateArr = date.split('-')
  const monthInt = dateArr[1]
  let monthName = monthNames[monthInt - 1]

  return `${monthName} ${dateArr[2]}, ${dateArr[0]}`
}

const isUrl = function (url) {
  let urlPattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$' + // fragment locator
      '',
    'i' + '' // string to match
  )
  return urlPattern.test(url)
}

export { dataURLToBlob, formatDate, isUrl }
